import ReportLoader from './ReportLoader';

export default ReportLoader;
